import { Typography } from "@mui/material";

export default function EmptyPaper({message}) {
    return (
        <Typography sx={{padding: '5px'}}>
            {message}
        </Typography>
    )
}